// extracted by mini-css-extract-plugin
module.exports = {"social":"_1UxnK","socialItem":"_20LBh","socialLink":"fFDBz"};